const Faqs = () => {
    const headings = document.querySelectorAll("[data-question]");
    const answers = document.querySelectorAll("[data-answer]");

    headings.forEach((heading) => {
        const target = heading.getAttribute("data-question");
        const content = document.querySelector(`[data-answer="${target}"]`);

        if (!content) return;

        heading.addEventListener("click", () => {
            const isOpen = heading.classList.contains("open");

            // Close all other items
            headings.forEach((h) => h.classList.remove("open"));
            answers.forEach((a) => {
                a.classList.remove("open");
                a.style.height = a.scrollHeight + "px"; // ensure it's set before collapsing
                requestAnimationFrame(() => {
                    a.style.height = "0px";
                });
            });

            if (!isOpen) {
                heading.classList.add("open");
                content.classList.add("open");

                // Set initial height to 0 to prep for transition
                content.style.height = "0px";

                // Wait for next frame to trigger transition
                requestAnimationFrame(() => {
                    content.style.height = content.scrollHeight + "px";
                });

                // After transition, reset to auto height
                const transitionEnd = () => {
                    content.style.height = "auto";
                    content.removeEventListener("transitionend", transitionEnd);
                };
                content.addEventListener("transitionend", transitionEnd);
            }
        });
    });
};

export default Faqs;